module.exports = __webpack_public_path__ + "img/02-1.88a6f3b0.png";